/**
 * @prettier
 */
import fastDeepEqual from 'fast-deep-equal';

export const deepEqual: DeepEqual = fastDeepEqual;

type DeepEqual = (arg1?: any, arg2?: any) => boolean;
